import { TrendingDown, TrendingUp } from "lucide-react";
import React, { useEffect } from "react";
import SimpleLineChart from "../SimpleLineChart";
import { usePriceUpdates } from "../../hooks/usePriceUpdates";
import { get7DayBtcClosingPrices } from "../../helperFunctions/get7DayBtcPrices";
import { Loader } from "lucide-react";

const LivePriceData = () => {
  const [btcWeeklyPrices, setBtcWeeklyPrices] = React.useState<any>([]);

  const { price: livePrice, change: btc24hChange } = usePriceUpdates();

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const prices = await get7DayBtcClosingPrices();
        setBtcWeeklyPrices(prices);
      } catch (err) {
        console.error("failed to load BTC prices", err);
      }
    };
    fetchPrices();
  }, []);

  return (
    <div className="bg-white text-black border border-gray-300 p-3 flex flex-col sm:flex-row gap-4 items-center shadow-sm">
      <div>
        <SimpleLineChart
          title={"BTC Last 7 Days"}
          data={btcWeeklyPrices}
          width={100}
          height={50}
        />
      </div>
      <div className="flex flex-col sm:flex-row justify-between items-center w-full">
        <div className="flex flex-col">
          <div className="text-xs text-gray-600 mb-0.5">Current BTC Price:</div>
          {livePrice ? (
            <div className="font-mono font-bold text-lg">
              ${livePrice.toLocaleString()} CAD
            </div>
          ) : (
            <Loader size={20} className="animate-spin" />
          )}

          <div className={`line-clamp-1 flex flex-row items-center gap-4`}>
            24 Hour Change:{" "}
            {btc24hChange ? (
              <p
                className={`${
                  btc24hChange < 0
                    ? "text-red-600 flex flex-row items-center gap-2"
                    : "text-green-600 flex flex-row items-center gap-2"
                }`}
              >
                {btc24hChange.toFixed(2)}%{" "}
                <span>
                  {btc24hChange < 0 ? (
                    <TrendingDown size={15} />
                  ) : (
                    <TrendingUp size={15} />
                  )}
                </span>
              </p>
            ) : (
              <Loader size={20} className="animate-spin" />
            )}
          </div>
        </div>

        <div className="text-xs text-gray-700 px-2 py-1 bg-gray-200 mt-4 sm:mt-0">
          Updated every minute
        </div>
      </div>
    </div>
  );
};

export default LivePriceData;
